import { useAnalytics } from "./useAnalytics";
import { useNativeMessage } from "./useNativeMessage";

export const useInitialApp = () => {
  useAnalytics();
  useNativeMessage();
};
